import * as React from 'react';
import { RootContext } from '../RootContainer';
import { View } from '../../_NEXT_components/View';
export function ViewContainer(_ref) {
  var children = _ref.children;

  var _React$useContext = React.useContext(RootContext),
      showLogo = _React$useContext.showLogo;

  return /*#__PURE__*/React.createElement(View, {
    showLogo: showLogo
  }, children);
}